// Gecerli minimal WASM modulu (add fonksiyonu) — CSP testi icin
const MINIMAL_WASM = new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00, 0x01, 0x07, 0x01, 0x60, 0x02, 0x7f, 0x7f, 0x01,
  0x7f, 0x03, 0x02, 0x01, 0x00, 0x07, 0x07, 0x01, 0x03, 0x61, 0x64, 0x64, 0x00, 0x00, 0x0a, 0x09,
  0x01, 0x07, 0x00, 0x20, 0x00, 0x20, 0x01, 0x6a, 0x0b,
]);

export async function isWasmCompilationAllowed(): Promise<boolean> {
  try {
    await WebAssembly.compile(MINIMAL_WASM);
    return true;
  } catch {
    return false;
  }
}

export function isCspWasmError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return (
    message.includes('Content Security') ||
    message.includes('unsafe-eval') ||
    message.includes('wasm-unsafe-eval')
  );
}

export const CSP_FIX_MESSAGE =
  'Kişi tanıma yüklenemedi. Sayfayı yenileyin; sorun sürerse sunucu CSP ayarını kontrol edin.';
